require("@babel/polyfill");
require('jquery.rut');

import Agendac2c from './components/Agendac2c';
import Swipeables from './components/Swipeables';
import mapServiceStation from './components/MapServiceStation/Core';


jQuery(document).ready(function () {

    ( new Swipeables() );
    ( new Agendac2c()  );

    if( document.getElementById('mapServiceStation') )
    {
        ( new mapServiceStation('mapServiceStation',{lat:'-33.451301574707',lng:'-70.665298461914'}) );
    }

    let  alphanumeric_guion_k = /[ Kk0-9-]/;

    let numeric = /^[0-9]+$/i



    jQuery(`.input-rut`).keypress(function (e) {
        this.value =  this.value.toUpperCase();
   
        if( this.value.length == 1 ){
          if( this.value == 0){
            this.value = '';
          }
        }else{
          if( this.value[0] == 0 )
          {
           let part1 = this.value.substring(0, 0);
           let part2 = this.value.substring(0 + 1, this.value.length);
           this.value = part1 + part2;
          }
        }
        
        });
      
    jQuery(`.input-rut`).keyup(function (e) {
        this.value =  this.value.toUpperCase();
   
        if( this.value.length == 1 ){
          if( this.value == 0){
            this.value = '';
          }
        }else{
          if( this.value[0] == 0 )
          {
           let part1 = this.value.substring(0, 0);
           let part2 = this.value.substring(0 + 1, this.value.length);
           this.value = part1 + part2;
          }
        }
        
        });
      
    jQuery(`.input-rut`).keypress(function (e) {
          var keyChar = String.fromCharCode(e.which || e.keyCode);
          return alphanumeric_guion_k.test(keyChar) ? keyChar : false;
      });
    
    
    jQuery(`.input-rut`).rut({
          formatOn: 'keyup',
          minimumLength: 8, 
    });

    jQuery(`#input_telefono`).keypress(function (e) {
      var keyChar = String.fromCharCode(e.which || e.keyCode);
      return numeric.test(keyChar) ? keyChar : false;
  });


    let alpha = /[ A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\u0027\s]/;

    jQuery(`#input_nombre`).keypress(function (e) {
      var keyChar = String.fromCharCode(e.which || e.keyCode);
      return alpha.test(keyChar) ? keyChar : false;
    });
 
  
});
require('../css/swiper.min.css');
